module.exports = __webpack_public_path__ + "static/img/103450.b88f3180.png";